// import Es6Promise from 'es6-promise';
// Es6Promise.polyfill();
import "@babel/polyfill";
import Vue from 'vue';
import Posts from '../vue/posts.vue';
import PostsNavigation from '../vue/postsNavigation.vue';
class posts {
	constructor() {
		
	}
	show(el) {
		this.postsApp = new Vue(Posts).$mount(el.querySelector('.posts-wrap')); 
	}

	navigation(el) {
		this.postsNavigationApp = new Vue(PostsNavigation).$mount(el.querySelector('.navigation-wrap')); 
	}
}

window.app.add('posts', new posts());